/* ============================================================
   SACRASOUL DESKTOP MEGA — controller (Variant A "Apothecary Ledger")
   Lane A build. Deferred ES module, loaded from header-mega-menu.liquid.
   - Panels hydrate from inert raw text on first pointer, focus, or touch intent.
   - Pointer-intent open (90ms), click toggle, Esc close, scrim close.
   - Full keyboard: aria-expanded, ArrowDown into panel, Esc restores focus.
   - Ledger-rail hover/focus crossfades the centre catblock (class swap only).
   - Panel tracks the live header bottom; closes on scroll so a hiding sticky
     header never leaves it floating.
   ============================================================ */
(function () {
  'use strict';

  var root = document.querySelector('.ssm-nav');
  if (!root) return;

  var scrim = document.getElementById('ssm-scrim');
  var panelMount = document.querySelector('[data-ssm-panel-mount]');
  var triggers = Array.prototype.slice.call(root.querySelectorAll('.ssm-trigger[data-panel]'));
  var panels = Array.prototype.slice.call(document.querySelectorAll('.ssm-panel'));
  if (!triggers.length) return;

  var OPEN_DELAY = 90;
  var CLOSE_GRACE = 240;
  var openTimer = null;
  var closeTimer = null;
  var currentPanel = null;
  var currentTrigger = null;
  var scrollAnchor = null;
  var shopBound = null;

  /* The raw source now arrives after <main>. Keep the rendered panels in their
     original header mount so DOM order, focus order and theme-editor behaviour
     stay identical to the pre-deferral implementation. */
  function adoptPanelsAtMount() {
    if (!panelMount) return;
    for (var i = 0; i < panels.length; i++) {
      if (panels[i].parentNode !== panelMount) panelMount.appendChild(panels[i]);
    }
  }

  /* ---- position panels flush under the live header ---- */
  function positionPanels() {
    var header = document.querySelector('.section-header');
    var top = header ? Math.max(header.getBoundingClientRect().bottom, 0) : 0;
    for (var i = 0; i < panels.length; i++) {
      panels[i].style.top = top + 'px';
      /* Bound the panel to what is actually on screen. Without this the panel has
         no height at all: at 820x1100 it measured 6206px, 84% of it unreachable
         (page scroll hard-closes below, the panel itself did not scroll). Measured
         innerHeight, never 100vh — on iOS Safari that is the LARGE viewport, so the
         bottom of the panel would sit under the browser chrome. */
      panels[i].style.maxHeight = (window.innerHeight - top) + 'px';
    }
    if (scrim) scrim.style.top = top + 'px';
  }

  /* Menu product images carry data-src and only load once the panel is first opened,
     so a closed menu never spends bandwidth on ~40 images at page load. */
  function loadMenuImages(item) {
    if (!item) return;
    var imgs = item.querySelectorAll('img[data-src]');
    for (var i = 0; i < imgs.length; i++) {
      /* A display:none shelf still downloads its images. The Shop panel holds 8
         catblocks and only one is .is-active, so opening it fetched ~35 images
         for the ~4 that are visible. An inactive shelf waits for its own reveal
         (activateCat / showLens call back in below).
         Test the image's own layout box, not the breakpoint: at 769-999px every
         catblock is display:block while the ledger rail that adds .is-active is
         display:none, so the old `:not(.is-active)` selector left 10 of 13 cells
         permanently blank. offsetParent is null only when the image (or an
         ancestor) is display:none, which is exactly the desktop inactive shelf. */
      if (imgs[i].offsetParent === null) continue;
      imgs[i].setAttribute('src', imgs[i].getAttribute('data-src'));
      imgs[i].removeAttribute('data-src');
    }
  }

  /* A shelf that just became visible pulls its own images. */
  function loadActiveShelves(scope) {
    (scope || document).querySelectorAll('.ssm-catblock.is-active').forEach(loadMenuImages);
  }

  /* Data Saver on, or a 2G-class link: do not make a breakpoint resize turn one
     already-open panel into an eager fetch of every shelf newly exposed by layout. */
  function saveDataOn() {
    var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (!c) return false;
    return c.saveData === true || /(^|-)2g$/.test(c.effectiveType || '');
  }

  function bindShopInteractions() {
    var shop = document.getElementById('ssm-shop');
    if (!shop || shopBound === shop) return;
    shopBound = shop;

    var rows = Array.prototype.slice.call(shop.querySelectorAll('.ssm-ledger__row'));
    var blocks = Array.prototype.slice.call(shop.querySelectorAll('.ssm-catblock'));
    var lensLinks = Array.prototype.slice.call(shop.querySelectorAll('.ssm-foot-intent a[data-lens]'));
    var lensTimer = null;
    var pinnedLens = null;

    function activateCat(cat) {
      window.requestAnimationFrame(function () {
        rows.forEach(function (r) { r.classList.toggle('is-active', r.getAttribute('data-cat') === cat); });
        blocks.forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-cat') === cat); });
        loadActiveShelves(shop);
      });
    }

    /* Ledger-foot intent lens: hover previews the honest shelf for a reason,
       a click pins it, a material row (or a second click) releases it. */
    function activeCat() {
      var r = shop.querySelector('.ssm-ledger__row.is-active');
      return r ? r.getAttribute('data-cat') : 'resins';
    }
    function showLens(lens) {
      window.requestAnimationFrame(function () {
        blocks.forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-intent') === lens); });
        lensLinks.forEach(function (a) { a.classList.toggle('is-lens', a.getAttribute('data-lens') === lens); });
        loadActiveShelves(shop);
      });
    }
    function hideLens() {
      lensLinks.forEach(function (a) { a.classList.remove('is-lens'); });
      activateCat(activeCat());
    }
    function clearPin() {
      pinnedLens = null;
      lensLinks.forEach(function (a) { a.classList.remove('is-pinned'); });
    }
    function restoreLens() {
      if (pinnedLens) showLens(pinnedLens); else hideLens();
    }

    rows.forEach(function (r) {
      var cat = r.getAttribute('data-cat');
      function toCat() {
        clearTimeout(lensTimer);
        clearPin();
        lensLinks.forEach(function (a) { a.classList.remove('is-lens'); });
        activateCat(cat);
      }
      r.addEventListener('mouseenter', toCat);
      r.addEventListener('focus', toCat);
    });

    lensLinks.forEach(function (a) {
      var lens = a.getAttribute('data-lens');
      a.addEventListener('mouseenter', function () {
        clearTimeout(lensTimer);
        lensTimer = setTimeout(function () { showLens(lens); }, 60);
      });
      a.addEventListener('mouseleave', function () {
        clearTimeout(lensTimer);
        lensTimer = setTimeout(restoreLens, 60);
      });
      a.addEventListener('focus', function () { clearTimeout(lensTimer); showLens(lens); });
      a.addEventListener('blur', function () { clearTimeout(lensTimer); restoreLens(); });
      a.addEventListener('click', function (e) {
        e.preventDefault();
        clearTimeout(lensTimer);
        if (pinnedLens === lens) {
          clearPin();
          hideLens();
        } else {
          pinnedLens = lens;
          lensLinks.forEach(function (x) { x.classList.toggle('is-pinned', x.getAttribute('data-lens') === lens); });
          showLens(lens);
        }
      });
    });
  }

  function bindPanelInteractions() {
    panels.forEach(function (panel) {
      if (panel.getAttribute('data-ssm-bound') === 'true') return;
      panel.setAttribute('data-ssm-bound', 'true');
      panel.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
      panel.addEventListener('mouseleave', scheduleClose);
    });
    bindShopInteractions();
  }

  /* Panels are server-rendered into an inert raw-text source. Parse on the first
     realistic nav intent so the existing 90ms hover-intent window absorbs the
     small synchronous parse and the panel is ready before it can become visible. */
  function hydratePanels() {
    if (panels.length) {
      adoptPanelsAtMount();
      bindPanelInteractions();
      return panels;
    }

    /* Prefer the section's own deferred-payload container; the document-wide
       fallback is the pre-existing behaviour for legacy in-header markup. */
    var payloadHost = document.querySelector('[data-ss-deferred-header-payloads]');
    var source = (payloadHost || document).querySelector('[data-ssm-panel-source]');
    if (!source) {
      /* Source missing or already consumed: a server-rendered fallback or a
         previous partial parse may exist. Re-query and fully bind every listener. */
      panels = Array.prototype.slice.call(document.querySelectorAll('.ssm-panel'));
      adoptPanelsAtMount();
      bindPanelInteractions();
      return panels;
    }

    try {
      var staging = document.createElement('template');
      staging.innerHTML = source.textContent.trim();
      if (!staging.content.querySelectorAll('.ssm-panel').length) return panels;
      (panelMount || source.parentNode).appendChild(staging.content);
      source.remove();
    } catch (err) {
      /* Keep the source intact for a later retry. A click can still navigate to
         the trigger's real Shopify menu URL instead of becoming a dead control. */
      return panels;
    }

    panels = Array.prototype.slice.call(document.querySelectorAll('.ssm-panel'));
    adoptPanelsAtMount();
    bindPanelInteractions();
    positionPanels();
    return panels;
  }

  function panelFor(trigger) {
    hydratePanels();
    return document.getElementById(trigger.getAttribute('data-panel'));
  }

  function openPanel(trigger) {
    var panel = panelFor(trigger);
    if (!panel) {
      /* The raw source is fetched on intent (assets/ss-header-payloads.js). If the
         pointer is still on the trigger when it lands, open then. */
      var hp = window.SacrasoulHeaderPayloads;
      if (hp && !hp.done) (hp.ready || hp.load()).then(function (ok) {
        if (ok && trigger.matches(':hover, :focus-within')) openPanel(trigger);
      });
      return false;
    }
    if (currentPanel && currentPanel !== panel) hardClose();
    clearTimeout(closeTimer);
    positionPanels();
    loadMenuImages(panel);
    if (panel.id === 'ssm-shop') warmShelvesInTurn(panel);
    panel.classList.add('is-open');
    if (scrim) scrim.classList.add('is-open');
    trigger.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
    currentPanel = panel;
    currentTrigger = trigger;
    /* Bank the position at open. Initialising this in the first scroll event
       made an arbitrarily large first jump the new baseline, so the panel
       survived the very scroll that should close it. */
    scrollAnchor = window.scrollY;
    return true;
  }

  function hardClose() {
    if (currentPanel) currentPanel.classList.remove('is-open');
    if (currentTrigger) {
      currentTrigger.classList.remove('is-open');
      currentTrigger.setAttribute('aria-expanded', 'false');
    }
    if (scrim) scrim.classList.remove('is-open');
    currentPanel = null;
    currentTrigger = null;
    scrollAnchor = null;
  }

  function scheduleClose() {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(hardClose, CLOSE_GRACE);
  }

  function navigateFallback(trigger) {
    var href = trigger.getAttribute('data-fallback-href');
    if (href) window.location.assign(href);
  }

  /* Hydrate synchronously at the start of intent, before mouseenter's 90ms open
     timer, click, or keyboard activation can ask for a panel. pointerover bubbles,
     so it covers both trigger buttons and the rest of the desktop nav root. */
  root.addEventListener('pointerover', hydratePanels, { passive: true });
  root.addEventListener('focusin', hydratePanels);
  root.addEventListener('touchstart', hydratePanels, { passive: true });

  triggers.forEach(function (trigger) {
    trigger.setAttribute('aria-haspopup', 'true');
    trigger.setAttribute('aria-expanded', 'false');

    trigger.addEventListener('mouseenter', function () {
      clearTimeout(closeTimer);
      clearTimeout(openTimer);
      openTimer = setTimeout(function () { openPanel(trigger); }, OPEN_DELAY);
    });
    trigger.addEventListener('mouseleave', function () {
      clearTimeout(openTimer);
      scheduleClose();
    });
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      var panel = panelFor(trigger);
      if (!panel) {
        /* A click that beats the on-intent payload fetch waits for it; only a
           fetch that has failed falls back to the trigger's real menu URL. */
        var hp = window.SacrasoulHeaderPayloads;
        if (hp && !hp.done) {
          (hp.ready || hp.load()).then(function (ok) {
            if (ok && panelFor(trigger)) openPanel(trigger); else navigateFallback(trigger);
          });
        } else {
          navigateFallback(trigger);
        }
      } else if (currentPanel === panel) {
        hardClose();
      } else {
        openPanel(trigger);
      }
    });
    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        trigger.click();
      } else if (e.key === 'ArrowDown') {
        e.preventDefault();
        if (!openPanel(trigger)) return;
        var panel = panelFor(trigger);
        var first = panel && panel.querySelector('a, button');
        if (first) first.focus();
      }
    });
  });

  /* Bind immediately when Liquid's mixed-case sentinel guard deliberately emitted
     live panels; deferred payloads bind inside hydratePanels after insertion. */
  adoptPanelsAtMount();
  bindPanelInteractions();

  if (scrim) scrim.addEventListener('click', hardClose);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && currentPanel) {
      var t = currentTrigger;
      hardClose();
      if (t) t.focus();
    }
  });

  /* Keyboard parity with the old mega: when focus leaves the open panel and its
     trigger (e.g. tabbing past the last cell), close — so focus never lands on
     page content behind the scrim. Esc still closes AND restores focus; this is a
     natural tab-away, so focus is left where the browser moved it. */
  document.addEventListener('focusin', function (e) {
    if (!currentPanel) return;
    var t = e.target;
    if (currentPanel.contains(t)) return;
    if (currentTrigger && currentTrigger.contains(t)) return;
    hardClose();
  });

  /* Reposition on resize. On scroll, small moves just re-anchor the panel
     (trackpad jiggle must not nuke it — demo keeps the panel open); past a
     real scroll the hiding sticky header would leave it floating, so close. */
  window.addEventListener('resize', function () {
    /* A desktop panel is display:none below the breakpoint. Clear its state
       there so it cannot reappear expanded after a rotation or resize back. */
    if (!window.matchMedia('(min-width: 769px)').matches) {
      hardClose();
      return;
    }
    positionPanels();
    /* Crossing a breakpoint (or a rotation) reveals cells that were display:none
       when the panel opened. Do not eagerly fetch that newly exposed set on a
       metered or 2G-class connection; direct category intent still loads its shelf. */
    if (currentPanel && !saveDataOn()) loadMenuImages(currentPanel);
  }, { passive: true });
  window.addEventListener('scroll', function () {
    if (!currentPanel) { scrollAnchor = null; return; }
    if (scrollAnchor === null) scrollAnchor = window.scrollY;
    if (Math.abs(window.scrollY - scrollAnchor) > 48) { scrollAnchor = null; hardClose(); }
    else positionPanels();
  }, { passive: true });
  /* Warm the menu photographs before they are asked for (2026-09-13). Sho:
     "the images in the menus on desktop don't load up quickly - Our Story, Why
     Sacrasoul, the Foundation. I always want those to load quickly." They
     ship as data-src and were fetched only when the panel opened, so the
     first hover always showed three empty frames for a network round trip.
     Two warmers, both cache-only (the data-src stays; openPanel still does the
     real assignment, which now hits cache):
       - on desktop with a real pointer, once the page is idle after load, the
         header payload is fetched and the About cards + the featured product
         photograph are warmed (four files, ~200 KB, never on save-data);
       - on trigger hover, that panel's visible images are warmed at once,
         ahead of the 90 ms open delay and the display:none skip inside
         loadMenuImages. */
  function warmImages(scope, low) {
    if (!scope || saveDataOn()) return [];
    var out = [];
    scope.querySelectorAll('img[data-src]').forEach(function (im) {
      var block = im.closest && im.closest('.ssm-catblock');
      if (!low && block && !block.classList.contains('is-active')) return;
      var w = new Image(); w.decoding = 'async'; if (low) w.fetchPriority = 'low';
      w.src = im.getAttribute('data-src'); out.push(w);
    });
    return out;
  }
  /* The Shop shelves, one after another (2026-09-13). Sho: the About photos now
     arrive at once, "but the shop, they still kind of load in front of me."
     Each ledger row swaps in its own shelf on hover and only then assigned the
     shelf's images, so every row was a fresh network round trip in view. Once
     the Shop panel is actually open on a pointer device, its other shelves are
     warmed in rail order, one shelf at a time at low priority: 16 distinct
     files, ~780 KB, never on save-data, never on touch, and only after the
     shopper has opened the menu. */
  var shelvesWarmed = null;
  function warmShelvesInTurn(shop) {
    if (!shop || shelvesWarmed === shop || saveDataOn()) return;
    if (!(window.matchMedia && matchMedia('(hover: hover)').matches)) return;
    shelvesWarmed = shop;
    var order = [];
    shop.querySelectorAll('.ssm-ledger__row').forEach(function (r) { order.push(r.getAttribute('data-cat')); });
    var blocks = Array.prototype.slice.call(shop.querySelectorAll('.ssm-catblock'));
    blocks.sort(function (a, b) {
      var ia = order.indexOf(a.getAttribute('data-cat')), ib = order.indexOf(b.getAttribute('data-cat'));
      return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib);
    });
    var k = 0;
    function next() {
      if (k >= blocks.length) return;
      var block = blocks[k++];
      if (block.classList.contains('is-active')) return next();
      var imgs = warmImages(block, true);
      if (!imgs.length) return next();
      var left = imgs.length, moved = false, guard;
      function advance() { if (moved) return; moved = true; clearTimeout(guard); setTimeout(next, 0); }
      function one() { if (--left === 0) advance(); }
      /* a request that never settles must not hold the rest of the rail */
      guard = setTimeout(advance, 4000);
      imgs.forEach(function (w) { if (w.complete) one(); else { w.onload = one; w.onerror = one; } });
    }
    next();
  }
  triggers.forEach(function (trigger) {
    trigger.addEventListener('mouseenter', function () {
      /* a touch tap also synthesises mouseenter; the open itself loads those */
      if (!(window.matchMedia && matchMedia('(hover: hover)').matches)) return;
      var panel = panelFor(trigger);
      if (panel) warmImages(panel);
    }, { passive: true });
  });
  function warmAtIdle() {
    if (document.prerendering || saveDataOn()) return;
    if (!(window.matchMedia && matchMedia('(min-width: 990px) and (hover: hover)').matches)) return;
    var hp = window.SacrasoulHeaderPayloads;
    var ready = (hp && !hp.done) ? (hp.ready || hp.load()) : Promise.resolve(true);
    Promise.resolve(ready).then(function (ok) {
      if (ok === false) return;
      hydratePanels();
      warmImages(document.getElementById('ssm-about'));
      warmImages(document.getElementById('ssm-shop'));
      var feat = document.querySelector('.ssm-featured');
      if (feat) warmImages(feat);
    }).catch(function () {});
  }
  var idle = window.requestIdleCallback || function (fn) { setTimeout(fn, 1500); };
  if (document.readyState === 'complete') idle(warmAtIdle, { timeout: 4000 });
  else window.addEventListener('load', function () { idle(warmAtIdle, { timeout: 4000 }); });
  positionPanels();
})();
